import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import Tabs from './components/Tabs'
import ShopBySize from './components/ShopBySize'
import NeedHelp from './components/NeedHelp'
import { SHOP_TIRES_TAB_NAME, NEED_HELP_TAB_NAME } from './constant'

const ShopByTireSizeStatic = ({ className, tab, setTabHandler, ...props }) =>
  <Wrapper className={ className }>
    <Tabs
      setTabHandler={ setTabHandler }
      tab={ tab } />
    { tab === SHOP_TIRES_TAB_NAME && (
      <ShopBySize { ...props } />
    )}
    { tab === NEED_HELP_TAB_NAME && <NeedHelp /> }
  </Wrapper>

export default ShopByTireSizeStatic

ShopByTireSizeStatic.propTypes = {
  className: PropTypes.string,
  setTabHandler: PropTypes.func,
  tab: PropTypes.string
}

const Wrapper = styled.div`
  padding: 25px 18px;
  ${Media.desktop`
    float: right;
    margin-top: -15px;
    border: 1px solid #dddddd;
    display: inline-block;
    width: 396px;
  `}
  ${Media.mobile`
    text-align: center;
  `}

  @media (max-width: 450px) {
    text-align: left;
  }
`
